

class bottomPopUp{
    constructor(){
        if (document.querySelectorAll("[data-safety-info]").length > 0) {
            let safetyDetails = document.querySelector("[data-safety-info]").innerHTML;
            document.querySelector("[data-toggle-btn]").addEventListener('click',(event)=>{
                event.preventDefault();
                this.togglePupup(event);
            })
        };
        if (window.location.pathname =="/pages/important-safety-information-ragwitek") {
            if(document.querySelectorAll(".safety-information").length) 
            {
                document.querySelector(".safety-information").remove()
            }
        }
        
    }
    togglePupup(event){
        let currentEle = event.currentTarget;
        let text =  currentEle.innerHTML;
        if (text == "Show More") {
            currentEle.innerHTML  = "Close"
        }else{
            currentEle.innerHTML  = "Show More"
        }
        document.querySelector("[data-safety-info]").classList.toggle("active")
    }
}
new bottomPopUp()